import { call, put, takeLatest } from 'redux-saga/effects';

import { handleResponseErrorCode, httpClient } from '../../utils';

import {
  cancelInvitationAction,
  deleteInvestorAction,
  generateCodeAction,
  getCountryCodeListAction,
  permissionAction,
  resendInvitationAction,
  userlistActionAll,
  userListDeleteNotificationAction,
  userReportInfoAction,
} from './actions';
import {
  CANCELINVITATION_REQUEST,
  DELETE_INVESTOR_IN_DETAIL_PAGE,
  DELETE_INVESTOR_IN_HOME_PAGE,
  DELETE_INVESTOR_IN_USER_LIST,
  DELETE_INVESTOR_REQUEST,
  GENERATECODE_REQUEST,
  INVITE_COUNTRY_CODE_REQUEST,
  PERMISSION_REQUEST,
  SENDINVITATION_REQUEST,
  USER_REPORT_INFO_REQUEST,
  USERLIST_REQUEST,
} from './constants';
import { userlistAction } from '../../components/UserList/templates/UserListContainer/UserListContainer.actions';
import {
  userAnalyticsAction,
  userInfoAction,
} from '../../components/UserDetail/templates/UserDetailContainer/UserDetailContainer.actions';
import api from '../../constants/apis';

export function* fetchPermission() {
  try {
    const { data: responseData } = yield call(httpClient.get, api.PERMISSION);

    yield put(permissionAction.success(responseData));
  } catch (err) {
    yield put(permissionAction.failure());
  }
}

export function* fetchUserlistAll() {
  try {
    const { data: responseData } = yield call(httpClient.post, `${api.USERLIST}`, {
      pageNum: 1,
      pageCount: 10,
    });

    yield put(userlistActionAll.success(responseData));
  } catch (err) {
    yield put(userlistActionAll.failure(err));
  }
}

export function* fetchGenerateCode({ data }) {
  const { location = {}, resendUserId } = data;
  const userId = !resendUserId ? location.state : resendUserId;
  try {
    const { data: responseData } = yield call(httpClient.post, `${api.USER}/${userId}/code`);

    yield put(generateCodeAction.success(responseData));
  } catch (err) {
    const error = handleResponseErrorCode(err);
    yield put(generateCodeAction.failure(error));
  }
}

export function* fetchResendInvitaion({ data }) {
  const { location = {}, resendUserId, payload, type } = data;
  const userId = !resendUserId ? location.state : resendUserId;
  try {
    const { data: responseData } = yield call(httpClient.post, `${api.USER}/${userId}/resend`);
    yield put(resendInvitationAction.success(responseData));
    if (type === 1) {
      yield put(
        userlistAction.request({
          ...payload,
        })
      );
    } else if (type === 2) {
      yield put(
        userInfoAction.request({
          ...data,
        })
      );
      yield put(userAnalyticsAction.request({ ...data }));
    } else if (type === 3) {
      yield put(
        userlistActionAll.request({
          ...data,
        })
      );
    }
  } catch (err) {
    const error = handleResponseErrorCode(err);
    yield put(resendInvitationAction.failure(error));
  }
}

export function* fetchUserReportInfoAction({ data }) {
  const { dateRange = 'last7days' } = data;

  try {
    const { data: responseData } = yield call(
      httpClient.get,
      `${api.USERREPORTINFO}?dateRange=${dateRange}`
    );

    yield put(userReportInfoAction.success(responseData));
  } catch (err) {
    const error = handleResponseErrorCode(err);
    yield put(userReportInfoAction.failure(error));
  }
}

export function* fetchCancelInvitaion({ data }) {
  const { location = {}, cancelUserId, payload, type } = data;
  const userId = !cancelUserId ? location.state : cancelUserId;
  try {
    const { data: responseData } = yield call(httpClient.post, `${api.USER}/${userId}/cancel`);
    yield put(cancelInvitationAction.success(responseData));
    if (type === 1) {
      yield put(
        userlistAction.request({
          ...payload,
        })
      );
    } else if (type === 2) {
      yield put(
        userInfoAction.request({
          ...data,
        })
      );
      yield put(userAnalyticsAction.request({ ...data }));
    } else if (type === 3) {
      yield put(
        userlistActionAll.request({
          ...data,
        })
      );
    }
  } catch (err) {
    const error = handleResponseErrorCode(err);
    yield put(cancelInvitationAction.failure(error));
  }
}

export function* fetchDeleteInvestor({ data }) {
  const { location = {}, deleteUserId, payload, type } = data;
  const userId = !deleteUserId ? location.state : deleteUserId;
  try {
    const { data: responseData } = yield call(httpClient.delete, `${api.USER}/${userId}/delete`);
    yield put(deleteInvestorAction.success(responseData));
    switch (type) {
      case DELETE_INVESTOR_IN_USER_LIST:
        yield put(
          userlistAction.request({
            ...payload,
          })
        );
        yield put(userListDeleteNotificationAction(true));
        break;
      case DELETE_INVESTOR_IN_HOME_PAGE:
        yield put(
          userlistActionAll.request({
            ...data,
          })
        );
        break;
      case DELETE_INVESTOR_IN_DETAIL_PAGE:
        yield put(userListDeleteNotificationAction(true));
        break;
      default:
        break;
    }
  } catch (err) {
    const error = handleResponseErrorCode(err);
    yield put(deleteInvestorAction.failure(error));
  }
}

export function* fetchCountryCodeList() {
  try {
    const { data: responseData } = yield call(httpClient.get, '/country/codes');
    yield put(getCountryCodeListAction.success(responseData));
  } catch (err) {
    const error = handleResponseErrorCode(err);
    yield put(getCountryCodeListAction.failure(error));
  }
}

export default [
  takeLatest(PERMISSION_REQUEST, fetchPermission),
  takeLatest(USERLIST_REQUEST, fetchUserlistAll),
  takeLatest(GENERATECODE_REQUEST, fetchGenerateCode),
  takeLatest(SENDINVITATION_REQUEST, fetchResendInvitaion),
  takeLatest(USER_REPORT_INFO_REQUEST, fetchUserReportInfoAction),
  takeLatest(CANCELINVITATION_REQUEST, fetchCancelInvitaion),
  takeLatest(DELETE_INVESTOR_REQUEST, fetchDeleteInvestor),
  takeLatest(INVITE_COUNTRY_CODE_REQUEST, fetchCountryCodeList),
];
